<template>
<div>
<v-navigation-drawer v-if="!$LOCAL" 
    app  
    clipped
    v-model="opened"
    :permanent="$vuetify.breakpoint.mdAndUp"
    :mini-variant="$vuetify.breakpoint.smAndDown ? false : mini"
    :temporary="$vuetify.breakpoint.smAndDown"
    :expand-on-hover="false" 
    :bottom="$vuetify.breakpoint.smAndDown"
    ref="drawer"
>
    <v-list v-if="!$LOCAL">
        <v-list-item to="/search">
            <v-list-item-action>
                <v-icon>{{ $APP == 'mmseqs' ? $MDI.Magnify : $MDI.Monomer }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Search</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item to="/multimer" v-if="$APP == 'foldseek'">
            <v-list-item-action>
                <v-icon>{{ $MDI.Multimer }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Multimer search</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item to="/interface" v-if="true && $APP == 'foldseek'">
            <v-list-item-action>
                <v-icon>{{ $MDI.Interface }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Interface search</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item to="/foldmason" v-if="$APP == 'foldseek'">
            <v-list-item-action>
                <v-icon>{{ $MDI.Wall }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>FoldMason MSA</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item to="/folddisco" v-if="$APP == 'foldseek'">
            <v-list-item-action>
                <v-icon>{{ $MDI.Motif }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Folddisco search</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item to="/riboseek" v-if="$APP == 'foldseek'">
            <v-list-item-action>
                <v-icon>{{ $MDI.Nucleotide }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Riboseek RNA search</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
      
        <v-list-group v-if="$route.name === 'result' || $route.name === 'riboseekresult'" v-model="expanded">
            <template slot="activator">
                <v-list-item-action>
                    <v-icon>{{ $MDI.FileDownloadOutline }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Downloads</v-list-item-title>
                </v-list-item-content>
            </template>
            
            <template v-if="!mini">
            <v-list-item
                @click="$ELECTRON ? electronDownload($route.params.ticket) : null"
                :href="$ELECTRON ? null : url('api/result/download/' + $route.params.ticket)"
                :target="$ELECTRON ? null : '_blank'"
                title="Download hit tables (M8 files)"
            >
                <v-list-item-action>
                    <v-icon>{{ $ELECTRON ? $MDI.FileDownloadOutline : $MDI.TableLarge }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Hit tables</v-list-item-title>
                    <v-list-item-subtitle>Archive of M8 files</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                @click="downloadJSON"
                style="padding-left: 16px;"
                title="Download all result data (JSON file)"
            >
                <v-list-item-action>
                    <v-icon>{{ $MDI.ApplicationBracesOutline }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>All data</v-list-item-title>
                    <v-list-item-subtitle>Reloadable JSON file</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            </template>
        </v-list-group>
        <v-list-group v-else-if="$route.name === 'foldmasonresult'" v-model="expanded">
            <template slot="activator">
                <v-list-item-action>
                    <v-icon>{{ $MDI.FileDownloadOutline }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Downloads</v-list-item-title>
                </v-list-item-content>
            </template>
            <template v-if="!mini">
            <v-list-item
                @click="downloadMSA"
                style="padding-left: 16px;"
                title="Download MSTAs (FASTA files)"
            >
                <v-list-item-action>
                    <v-icon>{{ $MDI.TextBoxOutline }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>MSTA</v-list-item-title>
                    <v-list-item-subtitle>.fasta file</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                @click="downloadJSON"
                style="padding-left: 16px;"
                title="Download all result data (JSON file)"
            >
                <v-list-item-action>
                    <v-icon>{{ $MDI.ApplicationBracesOutline }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>All data</v-list-item-title>
                    <v-list-item-subtitle>Reloadable JSON file</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            </template>
        </v-list-group>
        <v-list-group v-else-if="$route.name === 'folddiscoresult'" v-model="expanded">
            <template slot="activator">
                <v-list-item-action>
                    <v-icon>{{ $MDI.FileDownloadOutline }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Downloads</v-list-item-title>
                </v-list-item-content>
            </template>
            <template v-if="!mini">
            <v-list-item
                @click="$ELECTRON ? electronDownload($route.params.ticket) : null"
                :href="$ELECTRON ? null : url('api/result/folddisco/download/' + $route.params.ticket)"
                :target="$ELECTRON ? null : '_blank'"
                title="TODO"
            >
                <v-list-item-action>
                    <v-icon>{{ $ELECTRON ? $MDI.FileDownloadOutline : $MDI.TableLarge }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Hit tables</v-list-item-title>
                    <v-list-item-subtitle>Archive of M8 files</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
                @click="downloadJSON"
                style="padding-left: 16px;"
                title="Download all result data (JSON file)"
            >
                <v-list-item-action>
                    <v-icon>{{ $MDI.ApplicationBracesOutline }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>All data</v-list-item-title>
                    <v-list-item-subtitle>Reloadable JSON file</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item> -->
            </template>
        </v-list-group>

        <v-divider></v-divider>

        <router-view name="sidebar"></router-view>
        <history v-if="!$LOCAL" ref="history"/>

        <v-list-item v-if="$ELECTRON" to="/preferences">
            <v-list-item-action>
                <v-icon>{{ $MDI.Tune }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
                <v-list-item-title>Preferences</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</v-navigation-drawer>
<v-app-bar v-on:dblclick.native="electronHandleTitleBarDoubleClick()" app :height="$ELECTRON ? '72px' : '48px'" fixed clipped-left :class="['ml-0', 'pl-3', $ELECTRON ? 'pt-2' : null]" :style="{'-webkit-app-region': $ELECTRON ? 'drag' : null, '-webkit-user-select': $ELECTRON ? 'none' : null}">
    <v-app-bar-nav-icon v-if="!$LOCAL" :value="opened" @click.stop="toggleMini"></v-app-bar-nav-icon>
    <v-app-bar-title>
        <router-link v-if="!$LOCAL" :to="activeTool ? '/' + activeTool : '/'" style="color: inherit; text-decoration: none">{{ appName }}</router-link>
        <span v-if="$LOCAL">{{ appName }}</span>
    </v-app-bar-title>
    <img v-if="logo" :src="logo.src" :srcset="logo.srcset" :key="logo.src"
         style="margin-left:8px; display: inline-block; height: 48px; width: auto; vertical-align: middle"
         aria-hidden="true" />

    <v-spacer></v-spacer>
    <v-toolbar-items v-if="!$ELECTRON" class="hidden-sm-and-down">
        <v-btn text rel="external noopener" target="_blank"
               v-for="{title, url} in toolbarLinks" :key="title" :href="url">{{ title }}</v-btn>
    </v-toolbar-items>
</v-app-bar>

</div>
</template>

<script>
import buildFullPath from 'axios/lib/core/buildFullPath.js'
import { parseResultsList, download, djb2 } from './Utilities';
import History from './History.vue';

function toolPrefix(tool) {
    if (!tool) {
        return '';
    }
    return tool.replaceAll('-', '_').toUpperCase() + "_";
}

function toolString(strings, tool, key) {
    const prefixed = toolPrefix(tool) + key;
    if (prefixed in strings) {
        return strings[prefixed];
    }
    return (key in strings) ? strings[key] : null;
}

function getLinks(strings, prefix) {
    prefix = toolPrefix(prefix);

    if (!((prefix + 'NAV_URL_COUNT') in strings)) {
        return [];
    }

    const count = strings[prefix + 'NAV_URL_COUNT'];
    let arr = [];
    for (let i = 1; i <= count; i++) {
        const title = strings[prefix + "NAV_TITLE_" + i];
        const url = strings[prefix + 'NAV_URL_' + i];
        arr.push({ title, url });
    }
    return arr;
}

const LOGOS_1X = require.context('./assets', false, /^\.\/logo-.*_1x\.png$/);
const LOGOS_2X = require.context('./assets', false, /^\.\/logo-.*_2x\.png$/);

function getLogo(tool) {
    const key = `./logo-${tool}_1x.png`;
    if (!tool || !LOGOS_1X.keys().includes(key)) {
        return null;
    }
    return {
        src: LOGOS_1X(key),
        srcset: LOGOS_1X(key) + ' 1x, ' + LOGOS_2X(`./logo-${tool}_2x.png`) + ' 2x',
    };
}

export default {
    components : { History, },
    data: () => ({
        expanded: false,
        activeTool: '',
        opened: false,
        mini: true,
    }),
    created() {
        this.$root.$on('multi', this.shouldExpand);
    },
    mounted() {
        // defeat https://github.com/vuetifyjs/vuetify/pull/14523
        if (!__LOCAL__) Object.defineProperty(this.$refs.drawer._data, 'isMouseover', { get: () => { false } });
        this.updateTool();
    },
    beforeDestroy() {
        this.$root.$off('multi', this.shouldExpand);
    },
    watch: {
        expanded: function(event) {
            this.$root.$emit('multi', event);
        },
        $route: function() {
            this.updateTool();
        },
        isMobile: function(v) {
            if (v) {
                this.opened = false
            }
        },
    },
    computed: {
        appName() {
            return toolString(this.$STRINGS, this.activeTool, 'TOOL_NAME');
        },
        logo() {
            return getLogo(this.activeTool) || getLogo(__APP__);
        },
        toolbarLinks() {
            let toolLinks = getLinks(this.$STRINGS, this.activeTool);
            if (toolLinks.length == 0) {
                return getLinks(this.$STRINGS, '');
            }
            return toolLinks;
        },
        isMobile() {
            return this.$vuetify.breakpoint.smAndDown
        }
    },
    methods: {
        updateTool() {
            const comps = this.$router.getMatchedComponents()
            if (Array.isArray(comps) && comps.length > 0) {
                if ("tool" in comps[0]) {
                    this.activeTool  = comps[0].tool;
                }
            } else {
                this.activeTool = '';
            }
        },
        url(url) {
            // workaround was fixed in axios git, remove when axios is updated
            const fullUrl = buildFullPath(this.$axios.defaults.baseURL, url);
            return this.$axios.getUri({ url: fullUrl })
        },
        electronDownload(ticket) {
            this.saveResult(ticket);
        },
        log(message) {
            console.log(message);
            return message;
        },
        shouldExpand(expand) {
            if (expand)
                this.opened = expand;
                this.mini = false
        },
        toggleMini() {
            if (!this.mini && !this.$vuetify.breakpoint.smAndDown) {
                this.$refs.history.drawer = false
            }
            if (this.$vuetify.breakpoint.smAndDown) {
                this.opened = !this.opened
            } else {
                this.mini = !this.mini;
            }
        },
        electronHandleTitleBarDoubleClick() {
            this.handleTitleBarDoubleClick();
        },
        uploadJSON() {
            let file = this.$refs.upload.files[0];
            let hash = djb2(file.name);
            let fr = new FileReader();
            fr.addEventListener(
                "load",
                (e) => {
                    let data = parseResultsList(JSON.parse(e.target.result));
                    this.$root.userData = data;
                    this.$router.push({ name: 'result', params: { ticket: `user-${hash}`, entry: 0 }}).catch(error => {});
                }
            );
            fr.readAsText(file)
        },
        downloadJSON() {
            this.$root.$emit("downloadJSON");
        },
        downloadMSA() {
            this.$root.$emit("downloadMSA");
        }
    }
}
</script>

<style scoped>
::v-deep .v-app-bar-title__content {
    text-overflow: revert !important;
    width: auto !important;
}
::v-deep .theme--light.v-navigation-drawer {
    background-color: #f5f5f5;
    border-color: #f5f5f5;
    /* transition-duration: 0s !important; */
    /* transition-timing-function: linear; */
}

::v-deep .theme--dark.v-navigation-drawer {
    background-color: #212121;
    border-color: #212121;
}
.v-navigation-drawer--temporary {
    z-index: 99999;
}
</style>
